import React, { useEffect } from "react";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";

const CasestudyBanner = ({ onLoad }) => {
  return (
    <BannerWrapper onLoad={onLoad}>
      {({ useHighRes, imageLoaded, handleImageLoad }) => (
        <div
          className="container-fluid ctm-banner position-relative p-0"
          style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
        >
          <img
            src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/14.%20Case%20studies-1.webp"
            alt="Case Studies"
            className="w-100"
            loading={useHighRes ? "eager" : "lazy"}
            onLoad={handleImageLoad}
            fetchpriority={useHighRes ? "high" : "auto"}
          />
          {imageLoaded ? (
            <div className="ctm-text position-absolute text-white mt-lg-5 mt-3">
              <p className="fs4 text-uppercase busy">BLUEBERRY TRAVEL</p>
              <h1 className="banner-headings">Real Stories, Real Results</h1>
              <div className="d-flex common-second-content">
                <div className="ornge-border"></div>
                <div className="second-content">
                  Discover how Blueberry Travel has transformed corporate
                  journeys for companies worldwide. Dive into our real stories
                  and results that showcase our commitment to excellence.
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </BannerWrapper>
  );
};

export default CasestudyBanner;
